<template>
  <div class="locations">
    <transition-group
      class="location__list"
      tag="div"
      :css="false"
      @beforeEnter="handleFadeInInit"
      @enter="handleFadeInEnter"
      @leave="handleFadeInLeave"
    >
      <div
        v-for="(item, index) in animatedLocations"
        class="location"
        :class="{ hover: currentHover === index }"
        :key="item.name"
        :data-order="index"
        :data-delay-interval="50"
        :data-delay-base="400"
        @mouseenter="
          e => {
            handleMouseEnter(index, e);
          }
        "
        @mouseleave="handleMouseLeave"
      >
        <h3 class="location__title">
          <transition name="fadeIn">
            <img
              v-if="activeLocation === index"
              class="location__icon"
              src="@/assets/images/icons/address.svg"
            />
          </transition>
          {{ item.name }}
        </h3>
        <p
          class="location__address"
          v-for="(address, addressIndex) in item.address"
          :key="addressIndex"
        >
          {{ address }}
        </p>
        <br />
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import animations from '@/mixins/animations';

const LOCATION_PERIOD = 5000;

export default {
  mixins: [animations],
  data() {
    return {
      currentHover: null,
      locations: [
        {
          active: false,
          name: 'Taipei',
          address: [
            'Soda Laboratory',
            'No. 64 2/F, Section 2, Kaifeng St.',
            'Wanhua, Taipei City, Taiwan 108',
          ],
        },
        {
          active: false,
          name: 'Los Angeles',
          address: ['Soda Labs HQ', '10000 Washington Blvd. 6th Floor', 'Culver City, CA 90232'],
        },
        {
          active: false,
          name: 'Hong Kong',
          address: [
            'Unit A11, Room 801, 8th Floor Sunbeam',
            'Center, 27 Shing Yip Street, Kwun Tong, ',
            'Kowloon, Hong Kong Sar',
          ],
        },
      ],
      updateLocationTimer: null,
    };
  },
  computed: {
    ...mapGetters(['activeLocation', 'menuOpened']),
    animatedLocations() {
      return this.menuOpened ? this.locations : [];
    },
  },
  methods: {
    ...mapMutations(['updateActiveLocation', 'setActiveLocationTo']),
    handleMouseEnter(index) {
      this.setHover(index);
      this.clearTimer();
      this.setActiveLocationTo(index);
      this.setTimer();
    },
    handleMouseLeave() {
      this.resetHover();
    },
    clearTimer() {
      window.clearInterval(this.updateLocationTimer);
    },
    setTimer() {
      this.updateLocationTimer = window.setInterval(this.updateActiveLocation, LOCATION_PERIOD);
    },
    setHover(index) {
      this.currentHover = index;
    },
    resetHover() {
      this.currentHover = null;
    },
  },
  watch: {
    menuOpened: function(value) {
      if (value) {
        this.setTimer();
      } else {
        this.clearTimer();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.locations {
  display: none;
  @media (min-width: $sm) {
    flex: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.location {
  $this: &;
  display: block;
  color: $color-white;
  transition: transform 0.3s ease;
  &:first-child {
    margin-top: 1rem;
    @media (min-width: $xl) {
      margin-top: 2rem;
    }
  }
  &:not(:last-child) {
    margin-bottom: 2.5rem;
    @media (min-width: $xl) {
      margin-bottom: 3rem;
    }
  }

  &__list {
    padding-left: 9rem;
  }
  &__title {
    margin: 0;
    margin-bottom: 0.9rem;
    font-size: 1.875rem;
    position: relative;
    @media (min-width: $xl) {
      font-size: 2.625rem;
      margin-bottom: 1.5rem;
    }
  }
  &__icon {
    position: absolute;
    top: -0.5rem;
    left: -3.5rem;
  }
  &__address {
    opacity: 0.7;
    margin: 0;
    @media (min-width: $xl) {
      font-size: 1.25rem;
      line-height: 1.4;
    }
  }
  &.hover {
    transform: scale(1.05);
  }
}

.fadeIn-enter-active {
  animation: fadeIn 0.5s;
}
.fadeIn-leave-active {
  animation: fadeIn 0.5s reverse;
}
</style>
